import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1510Component } from './kymw1510.component';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { UpdateCwsIconFilePeriod } from './api-services/update-cws-icon-file-period-service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';

/**
 * アイコンファイル適用期間指定画面 モジュール設定クラス
 *
 * @export KYMW1510Module
 * @class KYMW1510Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1510Component,
  ],
  providers: [
    GetCwsIconBaseData,
    UpdateCwsIconFilePeriod,
    GetCodeListService
  ],
})
export class KYMW1510Module {
}
